<template>
  <div id="service-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-12 pl-0">
            <h3 class="modal-title">{{serviceName}}</h3>
          </div>
        </div>
        <div class="modal-body">
          <!-- 會員/網路服務資格-->
          <table class="table insurance-green" v-if="type===1">
            <thead>
              <tr>
                <th class="text-center" width="40%">資格項目</th>
                <th class="text-center" width="30%">狀態</th>
                <th class="text-center" width="30%">申辦時間</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableData" :key="`row-data-${i}`">
                <td>{{row.item}}</td>
                <td class="text-center">{{row.status}}</td>
                <td class="text-center">{{row.create_date | dateFormat}}</td>
              </tr>
            </tbody>
          </table>
          <table id="recommendTable" v-if="type===1">
            <tr>
              <td>
                <span style="font-size:20px;font-weight:600">網路服務開通:</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:18px;font-weight:600;margin-left:20px;">推薦以「雙證件拍照」開通網路服務:</span>
              </td>
              <td>
                <input
                  type="text"
                  style="position:absolute;left:-10000px;top:-10000px"
                  id="copyText"
                />
                <button type="button" class="btn btn-default btn-sm" @click="copy(credentialsText)">複製連結</button>
              </td>
              <td>
                <i
                  class="icon-facebook"
                  style="cursor:pointer;"
                  @click="encodeLink('fb', credentialsUrl)"
                ></i>
              </td>
              <td>
                <i class="icon-line" style="cursor:pointer;" @click="encodeLink('line', credentialsText)"></i>
              </td>
            </tr>
            <!--<tr>
              <td>
                <span style="font-size:18px;font-weight:600; margin-left:20px;">推薦以「國泰世華網銀認證」開通網路服務:</span>
              </td>
              <td>
                <input
                  type="text"
                  style="position:absolute;left:-10000px;top:-10000px"
                  id="copyText"
                />
                <button type="button" class="btn btn-default btn-sm" @click="copy(bankText)">複製連結</button>
              </td>
              <td>
                <i
                  class="icon-facebook"
                  style="cursor:pointer;"
                  @click="encodeLink('fb', bankUrl)"
                ></i>
              </td>
              <td>
                <i class="icon-line" style="cursor:pointer;" @click="encodeLink('line', bankText)"></i>
              </td>
            </tr>-->
          </table>
          <div class="row" v-if="type==2" :class="{'section-loading': isQueryType8}">
            <table class="table insurance-green" v-if="type===2">
              <thead>
                <tr>
                  <th class="text-center">會員註冊及數據綁定狀態</th>
                  <th class="text-center">註冊日期</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    <span v-if="tableData.create_tm">已註冊</span>
                    <span style="color: red;" v-if="!tableData.create_tm">尚未註冊</span>
                    ，
                    <span v-if="tableData.health_source == 'Y'">已開通數據</span>
                    <span style="color: red;" v-if="tableData.health_source == 'N'">未開通數據</span>
                  </td>
                  <td class="text-center">{{tableData.create_tm | dateFormat}}</td>
                </tr>
              </tbody>
            </table>
            <br />&nbsp;
            <table class="table insurance-green" v-if="type===2">
              <thead>
                <tr>
                  <th class="text-center">會員等級</th>
                  <th class="text-center">當前任務值</th>
                  <th class="text-center">會員年度到期日</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{tableData.level_nm}}</td>
                  <td class="text-center">{{tableData.experience | numberFormat}}<br>
                    <div v-if="tableData.experience !== '— —'">
                      <span style="color: #F58818;" v-if="tableData.experience < 12000">再{{tableData.upgrade_exp | numberFormat}}分{{tableData.upgrade_msg | numberFormat}}{{tableData.upgrade_nm | numberFormat}}
                      </span>
                      <span style="color: #F58818;" v-else>已為最高等級</span>
                    </div>
                  </td>
                  <td class="text-center">{{tableData.end_dt | dateFormat}}</td>
                </tr>
              </tbody>
            </table>
            <table id="recommendTable" v-if="type===2">
              <tr>
                <td>
                  <span style="font-size:20px;font-weight:600">我的專屬推薦碼：</span>
                  <span style="font-size:20px;font-weight:600">{{tableData.invitecode}}</span>
                </td>
                <td>
                  <input
                    type="text"
                    style="position:absolute;left:-10000px;top:-10000px"
                    id="copyText"
                  />
                  <button type="button" class="btn btn-default btn-sm" @click="copy(tableData.invitecode)">複製</button>
                  <button type="button" class="btn btn-default btn-sm" @click="copy('揪你加入「FitBack健康吧」健康計劃，點連結下載(開啟)國泰人壽APP並登入，再依步驟綁定就可以囉！' + tableData.inviteurl)">分享連結</button>
                </td>
              </tr>
            </table>
            <table v-if="type===2">
              <tr>
                <td>※「FitBack健康吧」註冊及綁定教學：</td>
              </tr>
              <tr>
                <td>進入國泰人壽APP點選下方「健康吧」，填寫身高與體重並勾選個資同意書，並選擇一個開通數據來源，以存取健康數據，各裝置綁定教學，請參考【
                  <a href="https://www.cathaylife.com.tw/cathaylife/-/media/079982D14F954B478B93E139FC5289FB.pdf?sc_lang=zh-TW&amp;_gl=1*kviwbs*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzc4OTIuNDMuMC4w" target="_blank" class="link">iOS</a>】、【
                  <a href="https://www.cathaylife.com.tw/cathaylife/-/media/D6AE7FE55F0044508B0304CD8378B441.pdf?sc_lang=zh-TW&amp;_gl=1*m3w979*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzg1NjMuNjAuMC4w" target="_blank" class="link">Android</a>】、【
                  <a href="https://www.cathaylife.com.tw/cathaylife/-/media/9E9D6249B12B4A69805F5D3984896466.pdf?sc_lang=zh-TW&amp;_gl=1*qvu4j7*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzg1ODEuNDIuMC4w" target="_blank" class="link">Garmin</a>】、【
                  <a href="https://www.cathaylife.com.tw/cathaylife/-/media/34C29FC89AF349488CBE0E30E178A016.pdf?sc_lang=zh-TW&amp;_gl=1*1n62wtd*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzg1OTIuMzEuMC4w" target="_blank" class="link">Fitbit</a>】教案。
                </td>
              </tr>
            </table>
          </div>
          <table class="table insurance-green" v-if="type===3">
            <thead>
              <tr>
                <th>幣別</th>
                <th>銀行別</th>
                <th>帳號後四碼</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableData" :key="`row-data-${i}`">
                <td>{{row.currency}}</td>
                <td>{{row.bank}}</td>
                <td>{{row.account}}</td>
              </tr>
            </tbody>
          </table>
          <p v-if="type===3" class="text-red">
            註:本頁面資訊為ID一指通，如欲查詢保單一指通，請至客戶保單資訊/保單號碼/保全給付，即可查詢保單一指通資訊。
          </p>

          <table class="table insurance-green" v-if="type===4">
            <thead>
              <tr>
                <th class="text-center">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableData" :key="`table-data-${i}`">
                <td class="text-center">{{row.email}}</td>
              </tr>
            </tbody>
          </table>

          <table class="table insurance-green" v-if="type===5">
            <thead>
              <tr>
                <th class="text-center">未辦理轉帳件保單號碼</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableData" :key="`table-data-${i}`">
                <td class="text-center">{{row.numbers}}</td>
              </tr>
            </tbody>
          </table>

          <div class="row" v-if="type==6" :class="{'section-loading': isQueryType5}">
            <table class="table insurance-green" v-if="type===6">
              <thead>
                <tr>
                  <th class="text-center">發卡銀行</th>
                  <th class="text-center">卡號後四碼</th>
                  <th class="text-center">信用卡有效期限</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="eCallData.isShow=='Y'">
                  <td class="text-center">{{eCallData.card_bank_name}}</td>
                  <td class="text-center">{{eCallData.card_no_4}}</td>
                  <td class="text-center">{{eCallData.card_name_ym}}</td>
                </tr>
                <tr v-else>
                  <td colspan="3" align="center">查無資料</td>
                </tr>
              </tbody>
            </table>
            <br />&nbsp;
            <table class="table insurance-green" v-if="type===6">
              <thead>
                <tr>
                  <th class="text-center">身分別</th>
                  <th class="text-center">姓名</th>
                  <th class="text-center">ID</th>
                  <th class="text-center">生日</th>
                  <th class="text-center">開通不便險</th>
                </tr>
              </thead>
              <tbody>
                <!--主會員資料-->
                <tr v-if="eCallData.vip_name || eCallData.isShow=='Y'">
                  <td class="text-center">{{eCallData.role_name}}</td>
                  <td class="text-center">{{eCallData.vip_name}}</td>
                  <td class="text-center">{{eCallData.vip_id}}</td>
                  <td class="text-center">{{eCallData.vip_brdy}}</td>
                  <td class="text-center">{{transformCase[eCallData.case]}}</td>
                </tr>
                <tr v-for="(row, i) in tableData" :key="`table-item-${i}`">
                  <td class="text-center">{{row.role_name}}</td>
                  <td class="text-center">{{row.rela_name}}</td>
                  <td class="text-center">{{row.rela_id}}</td>
                  <td class="text-center">{{row.rela_brdy}}</td>
                  <td class="text-center">{{transformCase[row.case]}}</td>
                </tr>
                <tr v-if="!eCallData.vip_name || eCallData.isShow=='N'">
                  <td colspan="5" align="center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-if="type===6" class="text-red">
            註1：客戶資料每日更新一次。
            <br />註2：如客戶欲變更信用卡(卡別、卡號、有效期限)，主會員進線0800投保同時一併變更信用卡資料。
          </p>

          <!-- 幣別 RADIO -->
          <template v-if="type===7">
            <div class="radio radio-inline" v-for="(row, i) in currData" :key="`radio-item-${i}`">
              <input
                type="radio"
                name="rdo"
                :id="row.curr"
                :value="row.curr"
                v-model="currency"
                :disabled="isQueryType6"
              />
              <label :for="row.curr">{{row.curr_name + "(" + row.count + ")"}}</label>
            </div>

            <div class="row" :class="{'section-loading': isQueryType6}">
              <!-- 幣別資料 -->
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th class="text-center">該幣別保單數</th>
                    <th class="text-center">該幣別可貸金額加總</th>
                    <th class="text-center">該幣別已貸金額加總</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="plLoanData.curr_count">
                    <td class="text-center">{{plLoanData.curr_count}}</td>
                    <td
                      class="text-center"
                    >{{plLoanData.loan_able_sum | emptyDashField | numberFormat}}</td>
                    <td
                      class="text-center"
                    >{{plLoanData.loan_bal_sum | emptyDashField | numberFormat}}</td>
                  </tr>
                  <tr v-if="!plLoanData.curr_count">
                    <td colspan="4" align="center" :class="{'section-loading': isQueryType7}" style="height: 40px;"></td>
                  </tr>
                </tbody>
              </table>
              <br />&nbsp;
              <!-- 保單資料 -->
              <p class="text-red">*下表資料隨保單交易/異動而更新且僅顯示可辦理保單貸款之商品，資料僅供參考，建議詳讀下方警語：
              <br />1.為避免交易日落差，協助客戶辦理前，請至「壽險核心系統>保全系統>保全給付試算>A貸款試算輸入」查詢即時資訊，實際狀況及貸款金額以保戶辦理時為準。
              <br />2.詳細已貸金額及保貸利息請至「管理大師>常用功能精華區>保費精華區>開立保貸利息」查詢。</p>
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th class="text-center" width="1%">保單號碼</th>
                    <th class="text-center" width="22%">險種名稱</th>
                    <th class="text-center" width="6%">利率</th>
                    <th class="text-center" width="19%">該幣別可貸金額</th>
                    <th class="text-center" width="14%">該幣別已貸金額</th>
                    <th class="text-center" width="12%">繳息終期</th>
                    <th class="text-center" width="12%">資料異動日</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="tableData.length > 0">
                    <tr v-for="(row, i) in tableData" :key="`table-item-${i}`">
                      <td>{{row.no}}</td>
                      <td>{{row.name}}</td>
                      <td class="text-right">{{row.rate}}</td>
                      <td class="text-right" v-html="checkCouldLoan(row)"></td>
                      <td class="text-right">{{row.isLoan | numberFormat}}</td>
                      <td class="text-right">{{row.interestEnd | dashFilter}}</td>
                      <td class="text-right">{{row.updTime | dashFilter}}</td>
                    </tr>
                    <tr v-if="tableData.length == 0">
                      <td colspan="6" align="center">查無資料</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div style="margin-left:auto; margin-right:0;position: relative;">
              <button class="btn btn-primary mr-0" style="float: right;" @click="encodeLink2()">申請貸款</button>
            </div>
          </template>


          <!-- 人臉辨識服務 -->
          <table class="table insurance-green" v-if="type===9">
            <thead>
              <tr>
                <th class="text-center" width="25%">狀態</th>
                <th class="text-center" width="50%">狀態說明</th>
                <th class="text-center" width="25%">申請時間</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">{{faceStatusData.title}}</td>
                <td class="text-center">{{faceStatusData.msg}}</td>
                <td class="text-center">{{faceServiceApplytimeHandler(faceStatusData)}}</td>
              </tr>
            </tbody>
          </table>
          <table class="mt-3" v-if="type===9">
            <tr>
              <td>
                <span style="font-size:20px;font-weight:600">人臉申請狀態說明 :</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:18px;font-weight:600;margin-left:20px;">1. 尚未申請 : 需申請</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:18px;font-weight:600;margin-left:20px;">2. 已完成申請 : 可驗證掃臉</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:18px;font-weight:600;margin-left:20px;">3. 已解除鎖定/停用 : 需重新申請</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:18px;font-weight:600;margin-left:20px;">4. 今日鎖定/鎖定 : 需解鎖後重新申請</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:18px;font-weight:600;margin-left:20px;">5. 傳入資訊有誤(錯誤碼0004)：請補上客戶生日資料</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:20px;font-weight:600">備註：</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="display: inline-flex; align-items: center;font-size:18px;font-weight:600;margin-left:20px;">其他狀態與流程說明請參考教案 : <a class="btn btn-default btn-sm ml-3" :href="faceStatusData.linkurl" target="_blank" style="vertical-align: middle">查看教案</a> </span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:18px;font-weight:600;margin-left:20px;">如有其他問題請聯繫：數位發展部 數位客戶經營科 #12815、#12819</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getCustInfo_ECall, getCustInfo_PlLoan, getCustFITBACK } from "../../service";
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";

export default {
  name: "ServiceModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    },
    instance: {
      type: Object,
      default: () => {
        return {};
      }
    },
    mmlUrl: {
      type: String,
      default: ""
    },
    fbMetaUrl: {
      type: String,
      default: ""
    },
    credentialsUrl: {
      type: String,
      default: ""
    },
    credentialsText: {
      type: String,
      default: ""
    },
    bankUrl: {
      type: String,
      default: ""
    },
    bankText: {
      type: String,
      default: ""
    },
    cwpUrl: {
      type: String,
      default: ""
    },
    cwpText: {
      type: String,
      default: ""
    },
  },
  filters: {
    dashFilter: function(val) {
      if (val == "— —" || val == undefined) {
        return "— —";
      } else {
        let data = val.split("-");
        data[0] = data[0] - 1911;
        return data.join("/");
      }
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    }
  },
  data() {
    return {
      serviceName: "",
      tableData: [],
      currData: [],
      currency: "",
      cust_id: "",
      eCallData: {
        role_name: "",
        isShow: "",
        card_bank_name: "",
        card_no_4: "",
        card_name_ym: "",
        column: "",
        vip_name: "",
        vip_id: "",
        vip_brdy: "",
        case: ""
      },
      plLoanData: {
        curr_count: "",
        loan_bal_sum: "",
        loan_able_sum: "",
        update_date: ""
      },
      fitbackData: {
        url: 'https://w3.cathaylife.com.tw/PIWeb/web/tc/9N0/%E6%AA%94%E6%A1%88/%E4%BA%BA%E8%87%89%E5%B0%88%E5%8D%80/%E4%BA%BA%E8%87%89%E8%BE%A8%E8%AD%98_NAP%E7%94%B3%E8%AB%8B%E6%95%99%E6%A1%88.pdf'
      },
      transformCase: {
        Y: "是",
        N: "否"
      },
      faceStatusData: {
      },
      isQueryType5: false,
      isQueryType6: false,
      isQueryType7: false,
      isQueryType8: false,
    };
  },
  watch: {
    type: "getService",
    currency: function(value) {
        this.setPlLoanData(this.instance.pl_loan, value);
    }
  },
  methods: {
    async getFitbackData(){
      this.isQueryType8 = true;
      await getCustFITBACK(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID, "").then(result => {
          if(result.header && result.header.status === '200'){
            this.instance.fitback =  result.body.memberfitbacklist.fitback
            this.isQueryType8 = false;
          }else{
            if(result.header && result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢會員FITBACK資料失敗,請重新操作'})
            }
          }
        })
    },
    async getPlLoanData(){
      this.isQueryType7 = true;
      await getCustInfo_PlLoan(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID, "").then(result => {
          if(result.header && result.header.status === '200'){
            this.instance.pl_loan =  result.body.plloanlist.pl_loan
            this.isQueryType7 = false;
          }else{
            if(result.header && result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢保單貸款失敗,請重新操作'})
            }
          }
        })
    },
    getEcall() {
      this.serviceName = "易CALL保";
      this.isQueryType5 = true;
      getCustInfo_ECall(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        this.cust_id,
        ""
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.isQueryType5 = false;
          this.setECallData(result.body.ecalllist.show_ecall);
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    async getService(val) {
      if (this.open) {
        switch (val) {
          case 1:
            this.serviceName = "會員/網路服務資格";
            this.tableData = this.instance.changeonline.map(item => {
              if(item.item.includes('FitBack')){
                return {
                item: item.item,
                status: item.status,
                create_date: item.creat_tm || "-",
                };
              }else{
                return {
                item: item.item,
                status: item.status,
                create_date: item.create_date || "-",
                };
              }
            });
            break;
          case 2:
            this.serviceName = "FitBack健康吧";
            await this.getFitbackData();
            this.setFitbackData(this.instance.fitback);
            if (this.instance.fitback.level == 0) {
              this.instance.fitback.level_nm = "— —";
              this.instance.fitback.experience = "— —";
            }
            if (this.instance.fitback.inviteurl) {
              let Url = new URL(this.instance.fitback.inviteurl);
              let Code = new URLSearchParams(Url.search);
              this.instance.fitback.invitecode = Code.get('invite_code');
            }
            this.tableData = this.instance.fitback;
            break;
          case 3:
            this.serviceName = "ID一指通";
            this.tableData = this.instance.payment_apply.map(item => {
              return {
                bank: item.bank_sname,
                account: item.acnt_no_4,
                currency: item.curr
              };
            });
            // this.tableData = [
            //   {
            //     currency: '台幣',
            //     bank: '國泰城東',
            //     account: '9999',
            //   },
            //   {
            //     currency: '台幣',
            //     bank: '國泰城東',
            //     account: '9999',
            //   }
            // ]
            break;
          case 4:
            this.serviceName = "行動服務";
            break;
          case 5:
            this.serviceName = "轉帳服務";
            this.tableData = this.instance.plcnos.map(item => {
              return {
                numbers: item.policy_no
              };
            });
            // this.tableData = [
            //   {
            //     numbers: '7777777777、8888888888、9999999999、8888888888'
            //   }
            // ]
            break;
          case 6:
            this.serviceName = "易CALL保";
            this.setECallData(this.instance.ecall);
            break;
          case 7:
            this.serviceName = "保單貸款";
            await this.getPlLoanData()
            this.setPlLoanData(this.instance.pl_loan);
            break;
          case 8:
            this.serviceName = "理賠抵繳";
            break;
          case 9:
            this.serviceName = "人臉辨識服務";
            this.faceStatusData = this.instance.status
            break;
        }
      }

      // get Detail from API
      this.records = [
        {
          series: 1,
          last: 192667874,
          shouldPayAt: "106/06/07",
          payAt: "106/06/07",
          rate: "1.99",
          pay: 200000,
          payment: "轉帳(合作金庫6076)"
        }
      ];
    },
    //帶入fitback資料
    setFitbackData(dataList) {
      this.fitbackData = dataList;
      console.log(this.fitbackData);
    },
    //帶入保單貸款資料
    setPlLoanData(dataList, curr) {
      if (dataList.data1 && this.currData.length == 0) {
        this.currData = dataList.data1.map((item) => {
          return {
            count: item.curr_count,
            curr: item.curr,
            curr_name: item.curr_name ? item.curr_name : "",
          };
        });
      }

      if (dataList.data2) {
        this.currency = curr ? curr : dataList.data1[0].curr;
        let data2 = dataList.data2.filter(
          (item) => item.curr == this.currency
        )[0];
        this.plLoanData.curr_count = data2.curr_count;
        this.plLoanData.loan_able_sum = data2.loan_able_sum;
        this.plLoanData.loan_bal_sum = data2.loan_bal_sum;
        this.plLoanData.update_date = this.formatDate(data2.upd_time);
      }

      this.tableData = [];
      if (dataList.data3) {
        this.tableData = dataList.data3
          .filter((item) => item.curr == this.currency)
          .map((item) => {
            let end_date;
            if (item.pay_int_end_date) {
              end_date =
                item.pay_int_end_date.indexOf("1001-01-01") > -1
                  ? "— —"
                  : item.pay_int_end_date;
            } else {
              end_date = "— —";
            }   
            //「資料異動日」欄位調整到只顯示到年/月/日
            let updateTime;
            if(item.upd_time){
              updateTime = item.upd_time.split('-').filter((item,index)=>index<=2).join('-');
            }
            let rate;
            if(item.type == '停效'){
              rate = item.pre_y_rate
            } else {
              rate = item.loan_rate
            }       
            return {
              no: item.policy_no,
              name: item.prod_nm,
              rate: rate ? Number(rate).toFixed(2) : "0.00",
              couldLoan: Number(item.loan_able),
              isLoan: Number(item.loan_bal),
              interestEnd: end_date,
              updTime: updateTime,
              type: item.type
            };
          });
      }
    },
    // 該幣別可貸金額欄位 - 停效保單一律顯示 「無，保單停效中(停效日期xxx/xx/xx)」
    checkCouldLoan(row){
      const numberFormat = this.$options.filters.numberFormat
      const emptyDashField= this.$options.filters.emptyDashField
      const dashFilter = this.$options.filters.dashFilter

      const upd_date = dashFilter(row.updTime)
      if(row.type == '停效'){
        return `無，保單停效中<br>(停效日期${upd_date})`
      }

      let value = row.couldLoan

      if(emptyDashField) value = emptyDashField(value)
      if(numberFormat) value = numberFormat(value)
      
      return value
    },
    checkRate(row){
      let rate = '' 
      if(row.type == '停效'){
        rate = row.pre_y_rate
      } else {
        rate = row.loan_rate
      }
      return rate ? rate.toFixed(2) : "0.00"
    },
    //帶入易Call保資料
    setECallData(dataList) {
      this.eCallData.isShow = dataList.isshow;
      this.eCallData.card_bank_name = dataList.data1[0].card_bank_name;
      this.eCallData.card_no_4 = dataList.data1[0].card_no_4;
      var card_name_ym = dataList.data1[0].card_name_ym;
      card_name_ym = card_name_ym
        ? card_name_ym.substring(0, 4) -
          1911 +
          "/" +
          card_name_ym.substring(4, 6)
        : "";
      this.eCallData.card_name_ym = card_name_ym;
      this.eCallData.column = dataList.data1[0].column;
      this.eCallData.vip_name = dataList.data1[0].vip_name;
      this.eCallData.vip_id = dataList.data1[0].vip_id;
      this.eCallData.vip_brdy = this.formatDate(dataList.data1[0].vip_brdy);
      this.eCallData.case = dataList.data1[0].case;
      this.eCallData.role_name = dataList.data1[0].role_name;

      this.tableData = [];
      if (this.eCallData.isShow == "Y") {
        this.tableData = dataList.data2.map(item => {
          return {
            rela_name: item.rela_name,
            rela_id: item.rela_id,
            rela_brdy: this.formatDate(item.rela_brdy),
            case: item.case,
            role_name: item.role_name
          };
        });
      }
    },
    faceServiceApplytimeHandler(data){
      return data.returncode == '2004' ? data.registeredtime : '— —'
    },
    //日期格式化 西元轉民國
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate)
          .format("YYYY-MM-DD")
          .split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    //判斷是line還是FB
    encodeLink(type, link) {
      if (this.isBox) {
        this.boxCathayShareLink(link);
      } else {
        let str = encodeURI(link);
        let url =
          type === "fb"
            ? `http://www.facebook.com/share.php?u=${str}`
            : `http://line.naver.jp/R/msg/text/?${str}`;
        window.open(url);
      }
    },
    //複製連結
    copy(url) {
      if (this.isBox) {
        this.boxCathayShareLink(url);
      } else {
        const copyText = document.getElementById("copyText");
        copyText.value = url;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (document.execCommand("cut")) {
          this.$toast.info({ title: "連結已複製" });
        } else {
          console.error("複製失敗");
        }
      }
    },
    encodeLink2() {
      if (this.isBox) {
        this.boxServiceItem({
          linkApp: "CathayLifeABMI",
          linkUrl: "NAP/ABNewContract",
          itemType: "AL",
          itemTitle: "保單貸款"
        });
      } else {
        let href = window.location.href; // 設定動態 url
        let netzone = "https://twas3.";
        if (href.indexOf("tmycrm") !== -1) {
          netzone = "https://twas3.";
        } else if (href.indexOf("smycrm") !== -1) {
          netzone = "https://swas3.";
        } else if (href.indexOf("mycrm") !== -1) {
          netzone = "https://was3.";
        }
        let url =
          netzone +
          "cathaylife.com.tw/ABWeb/servlet/HttpDispatcher/ABA0_1000/prompt?newTxRequest=true&syscode=AB&subcode=ABA0&DELIVER=N";
        window.open(url);
      }
    }
  }
};
</script>
